import { Component, OnInit } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { AppService } from "../services/app.service";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/throttleTime";
import "rxjs/add/observable/fromEvent";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import * as moment from "moment";
import { Router } from "@angular/router";

@Component({
  selector: "app-authorization-status",
  templateUrl: "./authorization-status.component.html",
})
export class AuthorizationStatusComponent implements OnInit {
  columnsData = [];
  columnsData1 = [];
  columnsData2 = [];
  columnsData3 = [];
  columnsData4 = [];
  columnsRes = [];
  p = 1;
  searchPatient = "";
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSizeItem = 10;
  sortColumn = "scheduledOnStr";
  orderColumn = "desc";
  routerName = "";
  today = new Date();
  newDate: Date;
  rowsData1 = [];
  rowsData2 = [];
  rowsData3 = [];
  rowsData4 = [];
  rowsData = [];
  startDate = "";
  fromMessageCentre: any;
  selectedtab: any;
  preauth: any;
  usertype: any;
  selectedDate: any;
  constructor(
    private modalService: BsModalService,
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private router: Router
  ) {}
  

  checklength(value) {
    if (value && value.toString().length > 1) {
      return value;
    } else if (value) {
      return "0" + value;
    }
    return "0";
  }

  mapAuthoStatusRow(obj) {
    return {
      param1: obj.patientFirstName ? obj.patientFirstName : "-",
      param2: obj.patientLastName ? obj.patientLastName : "-",
      param3: obj.createdOn ? obj.createdOn : "-",
      param4: obj.scheduledOnStr ? obj.scheduledOnStr : "-",
      param6:
        obj.preAuthorized && obj.preAuthorized === true
          ? "Yes"
          : "No",
      param5:
        obj.patientPhone && obj.patientPhoneCode === "+91"
          ? obj.patientPhoneCode +
            " " +
            obj.patientPhone.replace(/^(\d{0,5})(\d{0,5})/, "$1-$2")
          : obj.patientPhone && obj.patientPhoneCode === "+1"
          ? obj.patientPhoneCode +
            " " +
            obj.patientPhone.replace(
              /^(\d{0,3})(\d{0,3})(\d{0,4})/,
              "($1) $2-$3"
            )
          : "-",
      param12: obj.id,
      param11: obj.patientId,
      param7: obj.patientType === "IC" ? "IC" : "SchedMed",
      param13: "Double click for view",
    };
  }

  ngOnDestroy() {
    this.observeEvent.unsubscribe();
  }

  observeEvent: any;
  ngOnInit() {
    this.newDate = new Date();
    if (
      sessionStorage.getItem("selectedDate") != null &&
      sessionStorage.getItem("currentTab") != null
    ) {
      this.selectedDate = sessionStorage.getItem("selectedDate");
      this.selectedtab = sessionStorage.getItem("currentTab");
    }
    let date;
    let month1;
    if (this.selectedtab === "today" && this.selectedDate === "today") {
      date = new Date();
      month1 = date.getMonth();
      this.startDate =
        date.getFullYear() +
        "-" +
        this.checklength(month1 + 1) +
        "-" +
        this.checklength(date.getDate());
    }

    if (this.selectedtab === "today" && this.selectedDate === "tomorrow") {
      date = new Date();
      date.setDate(date.getDate() + 1);
      month1 = date.getMonth();
      this.startDate =
        date.getFullYear() +
        "-" +
        this.checklength(month1 + 1) +
        "-" +
        this.checklength(date.getDate());
    }

    if (this.selectedtab === "tomorrow" && this.selectedDate === "today") {
      date = new Date();
      date.setDate(date.getDate() + 1);
      month1 = date.getMonth();
      this.startDate =
        date.getFullYear() +
        "-" +
        this.checklength(month1 + 1) +
        "-" +
        this.checklength(date.getDate());
    }

    if (this.selectedtab === "tomorrow" && this.selectedDate === "tomorrow") {
      date = new Date();
      date.setDate(date.getDate() + 2);
      month1 = date.getMonth();
      this.startDate =
        date.getFullYear() +
        "-" +
        this.checklength(month1 + 1) +
        "-" +
        this.checklength(date.getDate());
    }

    if (this.selectedtab == "yesterday" && this.selectedDate == "today") {
      date = new Date();
      date.setDate(date.getDate() - 1);
      month1 = date.getMonth();
      this.startDate =
        date.getFullYear() +
        "-" +
        this.checklength(month1 + 1) +
        "-" +
        this.checklength(date.getDate());
    }

    if (this.selectedtab === "yesterday" && this.selectedDate === "tomorrow") {
      date = new Date();
      date.setDate(date.getDate());
      month1 = date.getMonth();
      this.startDate =
        date.getFullYear() +
        "-" +
        this.checklength(month1 + 1) +
        "-" +
        this.checklength(date.getDate());
    }

    if (this.selectedtab === "dayafter") {
      date = new Date();
      date.setDate(date.getDate() + 2);
      month1 = date.getMonth();
      this.startDate =
        date.getFullYear() +
        "-" +
        this.checklength(month1 + 1) +
        "-" +
        this.checklength(date.getDate());
    }

    this.fromMessageCentre = sessionStorage.getItem("fromMessagecentre");
    this.usertype = sessionStorage.getItem("usertype");

    if (this.fromMessageCentre === "true") {
      this.supportService.headerSubLittle.next("Home");
      this.rowsData = [
        {
          title: "First Name",
          sorting: true,
          name: "patientFirstName",
          sortGrid: "1",
        },
        {
          title: "Last Name",
          sorting: true,
          name: "patientLastName",
          sortGrid: "1",
        },
        {
          title: "Date Scheduled",
          sorting: true,
          name: "createdOn",
          dateFitler: true,
          sortGrid: "1",
        },
        {
          title: "Date of Service",
          sorting: true,
          name: "scheduledOnStr",
          dateFitler: true,
          sortGrid: "1",
        },
        { title: "Telephone Number" },
        { title: "Patient Type" },
      ];
      this.callByAdmin();
    } else {
      this.rowsData1 = [
        {
          title: "First Name",
          sorting: true,
          name: "patientFirstName",
          sortGrid: "1",
          underline: true,
        },
        {
          title: "Last Name",
          sorting: true,
          name: "patientLastName",
          sortGrid: "1",
          underline: true,
        },
        {
          title: "Date Scheduled",
          sorting: true,
          name: "createdOn",
          dateFitler: true,
          sortGrid: "1",
        },
        {
          title: "Date of Service",
          sorting: true,
          name: "scheduledOnStr",
          dateFitler: true,
          sortGrid: "1",
        },
        { title: "Telephone Number" },
        { title: "PreAuthorization Status" },
        { title: "Patient Type" },
      ];
      this.rowsData2 = [
        {
          title: "First Name",
          sorting: true,
          name: "patientFirstName",
          sortGrid: "2",
          underline: true,
        },
        {
          title: "Last Name",
          sorting: true,
          name: "patientLastName",
          sortGrid: "2",
          underline: true,
        },
        {
          title: "Date Scheduled",
          sorting: true,
          name: "createdOn",
          dateFitler: true,
          sortGrid: "2",
        },
        {
          title: "Date of Service",
          sorting: true,
          name: "scheduledOnStr",
          dateFitler: true,
          sortGrid: "2",
        },
        { title: "Telephone Number" },
        { title: "PreAuthorization Status" },
        { title: "Patient Type" },
      ];
      this.rowsData3 = [
        {
          title: "First Name",
          sorting: true,
          name: "patientFirstName",
          sortGrid: "3",
          underline: true,
        },
        {
          title: "Last Name",
          sorting: true,
          name: "patientLastName",
          sortGrid: "3",
          underline: true,
        },
        {
          title: "Date Scheduled",
          sorting: true,
          name: "createdOn",
          dateFitler: true,
          sortGrid: "3",
        },
        {
          title: "Date of Service",
          sorting: true,
          name: "scheduledOnStr",
          dateFitler: true,
          sortGrid: "3",
        },
        { title: "Telephone Number" },
        { title: "PreAuthorization Status" },
        { title: "Patient Type" },
      ];
      this.rowsData4 = [
        {
          title: "First Name",
          sorting: true,
          name: "patientFirstName",
          sortGrid: "4",
          underline: true,
        },
        {
          title: "Last Name",
          sorting: true,
          name: "patientLastName",
          sortGrid: "4",
          underline: true,
        },
        {
          title: "Date Scheduled",
          sorting: true,
          name: "createdOn",
          dateFitler: true,
          sortGrid: "4",
        },
        {
          title: "Date of Service",
          sorting: true,
          name: "scheduledOnStr",
          dateFitler: true,
          sortGrid: "4",
        },
        { title: "Telephone Number" },
        { title: "PreAuthorization Status" },
        { title: "Patient Type" },
      ];

      this.getAuthoStatus1("");
      this.getAuthoStatus2("");
      this.getAuthoStatus3("");
      this.getAuthoStatus4("");
    }

    this.observeEvent = this.supportService.gridSortingHeader.subscribe(
      (res) => {
        if (
          res &&
          res["length"] !== 0 &&
          res["routerName"] === this.routerName
        ) {
          this.sortColumn = res["name"];
          this.orderColumn = res["order"];
          this.currentPage = 1;
          if (res["girdNo"] === "1") {
            if (this.fromMessageCentre === "true") {
              this.callByAdmin();
            } else {
              this.getAuthoStatus1("");
            }
          }
          if (res["girdNo"] === "2") {
            this.getAuthoStatus2("");
          }
          if (res["girdNo"] === "3") {
            this.getAuthoStatus3("");
          }
          if (res["girdNo"] === "4") {
            this.getAuthoStatus4("");
          }
        }
      }
    );

    this.checkUrl();
  }

  navigateToMessagecenter() {
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "message-center",
    ]);
  }

  callByAdmin() {
    this.preauth = sessionStorage.getItem("preauth");
    let data;
    if (this.preauth === "Yes") {
      data = {
        pageNumber: this.currentPage,
        pageRecord: this.maxSizeItem,
        search: this.searchPatient,
        fromDate: this.startDate,
        toDate: this.startDate,
        type: "preauthorized",
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
      };
    } else {
      data = {
        pageNumber: this.currentPage,
        pageRecord: this.maxSizeItem,
        search: this.searchPatient,
        fromDate: this.startDate,
        toDate: this.startDate,
        type: "nonauthorized",
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
      };
    }

    this.appService.getgriddata(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsData = [];
            this.columnsRes = res["entity"];

            this.columnsRes.forEach((obj) => {
              this.columnsData = this.columnsData.concat({
                param1: obj.patientFirstName ? obj.patientFirstName : "-",
                param2: obj.patientLastName ? obj.patientLastName : "-",
                param3: obj.createdOn ? obj.createdOn : "-",
                param4: obj.scheduledOnStr ? obj.scheduledOnStr : "-",
                param5:
                  obj.patientPhone && obj.patientPhoneCode === "+91"
                    ? obj.patientPhoneCode +
                      " " +
                      obj.patientPhone.replace(/^(\d{0,5})(\d{0,5})/, "$1-$2")
                    : obj.patientPhone && obj.patientPhoneCode === "+1"
                    ? obj.patientPhoneCode +
                      " " +
                      obj.patientPhone.replace(
                        /^(\d{0,3})(\d{0,3})(\d{0,4})/,
                        "($1) $2-$3"
                      )
                    : "-",
                param12: obj.id,
                param11: obj.patientId,
                param6:
                  obj.patientType && obj.patientType === "IC"
                    ? "IC"
                    : "SchedMed",
                param13: "Double click for view",
              });
            });
            this.totalItems = res["count"];
          } else {
            this.columnsData = [];
            this.totalItems = 0;
          }
        } else {
          this.columnsData = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  onBlurSearchMethod() {
    if (this.fromMessageCentre === "true") {
      this.callByAdmin();
    } else {
      this.getAuthoStatus1("");
      this.getAuthoStatus2("");
      this.getAuthoStatus3("");
      this.getAuthoStatus4("");
    }
  }

  checkUrl() {
    const path = this.location.path().split("/");
    if (path.length === 3) {
      this.routerName = path[2];
    }
  }

  pageChanged(event) {
    this.currentPage = event.page;
    this.callByAdmin();
  }

  getAuthoStatus1(event) {
    let data;
    if (event) {
      data = {
        pageNumber: 0,
        pageRecord: 0,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        preAuth: "all",
        startDate: moment(this.today).format("YYYY-MM-DD"),
        endDate: moment(this.today).format("YYYY-MM-DD"),
        tcId: localStorage.getItem("testCenterId"),
      };
    } else {
      data = {
        pageNumber: 0,
        pageRecord: 0,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        preAuth: "all",
        startDate: moment(this.today).format("YYYY-MM-DD"),
        endDate: moment(this.today).format("YYYY-MM-DD"),
        tcId: localStorage.getItem("testCenterId"),
      };
    }
    this.appService.getAuthoStatus(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsData1 = [];
            this.columnsRes = res["entity"];

            this.columnsRes.forEach((obj) => {
              this.columnsData1 = this.columnsData1.concat({
                param1: obj.patientFirstName ? obj.patientFirstName : "-",
                param2: obj.patientLastName ? obj.patientLastName : "-",
                param3: obj.createdOn ? obj.createdOn : "-",
                param4: obj.scheduledOnStr ? obj.scheduledOnStr : "-",
                param5:
                  obj.patientPhone && obj.patientPhoneCode == "+91"
                    ? obj.patientPhoneCode +
                      " " +
                      obj.patientPhone.replace(/^(\d{0,5})(\d{0,5})/, "$1-$2")
                    : obj.patientPhone && obj.patientPhoneCode == "+1"
                    ? obj.patientPhoneCode +
                      " " +
                      obj.patientPhone.replace(
                        /^(\d{0,3})(\d{0,3})(\d{0,4})/,
                        "($1) $2-$3"
                      )
                    : "-",
                param12: obj.id,
                param11: obj.patientId,
                param6:
                  obj.preAuthorized && obj.preAuthorized === true
                    ? "Yes"
                    : "No",
                param7: obj.patientType === "IC" ? "IC" : "SchedMed",
                param13: "Double click for view",
              });
            });
            this.totalItems = res["count"];
          } else {
            this.columnsData1 = [];
            this.totalItems = 0;
          }
        } else {
          this.columnsData1 = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  getAuthoStatus2(event) {
    const startDate1 = this.today;
    const newdate = moment(startDate1, "DD-MM-YYYY").add("days", 1);
    const day = newdate.format("DD");
    const month = newdate.format("MM");
    const year = newdate.format("YYYY");
    let data;
    if (event) {
      data = {
        pageNumber: 0,
        pageRecord: 0,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        preAuth: "all",
        startDate: year + "-" + month + "-" + day,
        endDate: year + "-" + month + "-" + day,
        tcId: localStorage.getItem("testCenterId"),
      };
    } else {
      data = {
        pageNumber: 0,
        pageRecord: 0,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        preAuth: "all",
        startDate: year + "-" + month + "-" + day,
        endDate: year + "-" + month + "-" + day,
        tcId: localStorage.getItem("testCenterId"),
      };
    }

    this.appService.getAuthoStatus(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsData2 = [];
            this.columnsRes = res["entity"];
            this.columnsRes.forEach((obj) => {
              this.columnsData2 = this.columnsData2.concat(
                this.mapAuthoStatusRow(obj)
              );
            });
            this.totalItems = res["count"];
          }
        } else {
          this.columnsData2 = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  getAuthoStatus3(event) {
    const startDate1 = this.today;
    const newdate = moment(startDate1, "DD-MM-YYYY").add("days", 2);
    const day = newdate.format("DD");
    const month = newdate.format("MM");
    const year = newdate.format("YYYY");
    let data;
    if (event) {
      data = {
        pageNumber: 0,
        pageRecord: 0,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        // 'patientType': 'all',
        search: this.searchPatient,
        preAuth: "all",
        startDate: year + "-" + month + "-" + day,
        endDate: year + "-" + month + "-" + day,
        tcId: localStorage.getItem("testCenterId"),
      };
    } else {
      data = {
        pageNumber: 0,
        pageRecord: 0,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        // 'patientType': 'all',
        search: this.searchPatient,
        preAuth: "all",
        startDate: year + "-" + month + "-" + day,
        endDate: year + "-" + month + "-" + day,
        tcId: localStorage.getItem("testCenterId"),
      };
    }

    this.appService.getAuthoStatus(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          if (res["entity"]) {
            this.columnsData3 = [];
            this.columnsRes = res["entity"];
            this.columnsRes.forEach((obj) => {
              this.columnsData3 = this.columnsData3.concat(
                this.mapAuthoStatusRow(obj)
              );
            });
            this.totalItems = res["count"];
          }
        } else {
          this.columnsData3 = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  getAuthoStatus4(event) {
    const startDate1 = this.today;
    const newdate = moment(startDate1, "DD-MM-YYYY").add("days", 4);
    const day = newdate.format("DD");
    const month = newdate.format("MM");
    const year = newdate.format("YYYY");
    let data;
    if (event) {
      data = {
        pageNumber: 0,
        pageRecord: 0,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        preAuth: "all",
        startDate: year + "-" + month + "-" + day,
        endDate: "",
        tcId: localStorage.getItem("testCenterId"),
      };
    } else {
      data = {
        pageNumber: 0,
        pageRecord: 0,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        preAuth: "all",
        startDate: year + "-" + month + "-" + day,
        endDate: "",
        tcId: localStorage.getItem("testCenterId"),
      };
    }

    this.appService.getAuthoStatus(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsData4 = [];
            this.columnsRes = res["entity"];
            this.columnsRes.forEach((obj) => {
              this.columnsData4 = this.columnsData4.concat(
                this.mapAuthoStatusRow(obj)
              );
            });
            this.totalItems = res["count"];
          }
        } else {
          this.columnsData4 = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }
}
